import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=a7a2a8b6&scoped=true"
import script from "./ArticlePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlePreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticlePreview.vue?vue&type=style&index=0&id=a7a2a8b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a2a8b6",
  null
  
)

export default component.exports